import { render, staticRenderFns } from "./AddOpenAPISidePanel.vue?vue&type=template&id=bc179304&"
import script from "./AddOpenAPISidePanel.vue?vue&type=script&lang=ts&"
export * from "./AddOpenAPISidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports